var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBefore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M6 5v14c0 1.103.747 2 1.667 2h11.666c.92 0 1.667-.897 1.667-2V5c0-1.103-.747-2-1.667-2H7.667C6.747 3 6 3.897 6 5m1.667 14v-9h11.667l.001 9zM1 11V3l4 4z"
})));
export default SvgBefore;